import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageInsitutionManagementService } from '../../ph-bhp-feature-package-insitution-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization'

@Component({
  selector: 'app-view-layout',
  templateUrl: './view-layout.component.html',
  styleUrls: ['./view-layout.component.css']
})
export class ViewLayoutComponent implements OnInit {

  institutionData: any;
  institutionId = 0;

  institutionDetailTabs = [];
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    public config: AppConfig,
    private service: PHBHPFeaturePackageInsitutionManagementService,
    public layoutService: PHBHPLayoutPackageService
  ) { }

  ngOnInit() {
    this.institutionId = this.activatedRoute.snapshot.params.id;
    this.loadTabs();
    this.getInstitutionDetails();
  }

  loadTabs() {
    this.institutionDetailTabs = [
      {
        title: 'INSTITUTION_MANAGEMENT.OVERVIEW', // 'Overview',
        url: `./overview`
      },
      {
        title:  'INSTITUTION_MANAGEMENT.USERS', // 'Users',
        url: `./institutionUsers`
      }
    ];
  }

  getInstitutionDetails() {
    this.layoutService.showLoader = true;
    this.service.GetInstitutionDetails(this.institutionId).subscribe((res: any) => {
      this.institutionData = res;
      this.layoutService.showLoader = false;
    });
  }

  backToManageInstitution() {
    this.router.navigate(['institution']);
  }
}
